<template>
  <section id="benefits" class="example-bg bg-no-repeat bg-cover bg-center text-white pt-48 pb-64 sm:pt-64 xxl:py-80">
    <div class="container md:px-24">
      <div class="benefits-block leading-loose" v-html="htmlString"/>
    </div>
  </section>
</template>

<script>
export default {
  props: {
    htmlString: {
      type: String,
      default: null,
    },
  },
};
</script>

<style lang="sass" scoped>
.example-bg
  background-image: url("~assets/img/match/bg-golf-groot.svg")

.benefits-block
  min-height: 60vh
  @media(min-width: theme('screens.md'))
    columns: 2
    column-gap: 10%

  ::v-deep h2
    color: white
</style>
